import React from 'react'
import Button from '@mui/material/Button'

export const MyMButton = (props) => {
  const { fontSize, align, ...other } = props;
  return (
    <Button
      style={{
        fontSize: fontSize ?? '1rem',
        textTransform: 'initial',
        backgroundColor: '#EEEEEE',
        color: 'black',
        ':hover': {
          'backgroundColor': '#EEEEEE',
        }
      }}
      variant="contained"
      align={align ?? 'inherit'}
      {...other} >
      {props.children}
    </Button>
  )
}

export const MyMVariantButton = (props) => {
  const { variant, ...other } = props;
  return (
    <Button style={{ textTransform: 'initial' }} variant={variant} {...other}>
      {props.children}
    </Button>
  )
}

export const MyMSearchButton = (props) => {
  const { handleSearch, searchText } = props;

  return (
    <MyMButton
      onClick={handleSearch}>
      {searchText}
    </MyMButton>
  )
}

export const MyMCloseButton = (props) => {
  const { handleClose, closeText, ...other } = props;

  return (
    <MyMButton
      onClick={handleClose ? handleClose : () => window.close()} {...other}>
      {closeText}
    </MyMButton>
  )
}